import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import VerifiedIcon from 'components/VerifiedIcon'

import classes from './UserName.module.scss'

export const VERIFIED_REVIEWER = 'Verified reviewer'

/** @type {import("./types").default} */
const UserName = ({ userName, isAnonymous = false, isVerified = false, isSnippet = false, userInfo }) => {
  const hasPicture = isSnippet ? userInfo?.avatar : userInfo?.picture_url || userInfo?.pictureUrl
  const [firstName, lastName] = userName && userName.length > 0 ? userName?.split(' ') : ['', '']
  const shortName = lastName && lastName.length > 0 ? `${firstName} ${lastName[0]}.` : firstName || userName

  return (
    <div className={clsx(classes.userNameContainer)}>
      <Typography
        variant="heading-sm"
        className={clsx(
          classes.userName,
          { [classes.snippet]: isSnippet },
          {
            [classes.snnipetNameExp]: isSnippet,
          },
          {
            [classes.userNameExp]: !isSnippet,
          }
        )}
      >
        {isAnonymous || !userName ? VERIFIED_REVIEWER : shortName}
      </Typography>

      <VerifiedIcon
        validationsPassed={userInfo?.validations_passed || []}
        isVerified={isVerified}
        isValidated={userInfo?.is_validated}
        hasPicture={!!hasPicture}
      />
    </div>
  )
}

export default UserName
